var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.675 1.933a1.1 1.1 0 0 1 .325.801 1.1 1.1 0 0 1-.325.801l-8.408 8.532-1.58 1.603c-.216.22-.48.33-.789.33-.31 0-.573-.11-.79-.33L4.53 12.067.325 7.801A1.1 1.1 0 0 1 0 7a1.1 1.1 0 0 1 .325-.801l1.58-1.603c.216-.22.48-.33.79-.33.309 0 .572.11.789.33l3.414 3.476L14.516.33c.217-.22.48-.33.79-.33.31 0 .573.11.79.33l1.579 1.603Z",
    fill: "#3bb273"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskDefault);
export default __webpack_public_path__ + "static/media/task-default.8ec4c40d.svg";
export { ForwardRef as ReactComponent };